import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NicaMaster } from '../../../components/nica-master-component/nica-master.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { FormsTemplateService } from '../../../services/forms-template.service';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-gestione-carichi-movimento',
  templateUrl: './gestione-carichi-movimento.component.html',
  styleUrls: ['./gestione-carichi-movimento.component.css']
})
export class GestioneCarichiMovimentoComponent extends NicaMaster implements OnInit {
  @Input() itemData: any;
  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() emittendSelectionRow: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  startForm: boolean = false;
  CustomButtonForm
  totalPesoScaricato: number;
  disabledButtons: boolean = false;
  maxTotaleScaricabile: number;
  showPopupPercentuale: boolean = false;
  textPercentValue: number;
  buttonsPercentPopUp
  heightForm = 590
  newdata
  oldData
  constructor(
    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
    //    this.loader.show()
    this.activatedroute.queryParams
      .subscribe(params => {

        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName


        this.showToolBar = false //Per ora ...

        this.setGlobalVariableFromParams(params);
        // this.loader.hide()

      });
  }


  ngOnInit() {

    this.buttonsPercentPopUp =
    {
      /* icon: 'dx-icon glyphicon mdi mdi-playlist-plus', */
      class: 'blueButton',
      text: 'Conferma',
      type: 'default',

      onClick: ($event) => {

        this.setPercent($event)
      },
    }

    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.titleDynamic = this.itemData[0].title;
      this.filterID = this.itemData[0].data;
      if (typeof this.itemData[0]['heightForm'] != 'undefined') {
        this.heightForm = this.itemData[0]['heightForm'];
      }
      this.setVariableScarico();

    } else {
      this.activatedroute.queryParams
        .subscribe(params => {

          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName

          this.setGlobalVariableFromParams(params);
          this.setVariableScarico()

        });
    }
  }

  setVariableScarico() {


    //this.SubjectCall = 'scaricoRifiuto'

    let formData = this.filterID
    let newData = []
    for (let x in formData) {
      newData = { ...newData, [x]: formData[x] }
    }
    let dataToSend = newData;

    if (typeof dataToSend['isGrid'] != 'undefined') {
      this.disabledButtons = true
    }


    this.rowData = [];
    let idMovimento = formData.idMovimento;
    this.rowData['idMovimento'] = idMovimento;

    let filter = '';

    //listaMagazzini.push(formData.magazzinoDestinatario_Descrizione)

    //this.rowData['ListaIdMagazzino'] = [formData.idMagazzinoDestinatario];

    this.rowData['idDestinatario'] = formData.idDestinatario;
    this.rowData['IdProduttoreMovScarico'] = formData.idProduttore;
    this.rowData['idProduttore'] = formData.idProduttore;

    this.rowData['ListaIdPosizioniDiCarico'] = [formData.idPosizioneCausale];
    //this.rowData['riferimentoEER'] = formData.riferimentoEER

    let ListaIdTipoCarico = []
    let idOperazioneRD = formData.idOperazioneRD.toLowerCase()
    if (idOperazioneRD) {
      let idOperazioneR = idOperazioneRD.includes('r');
      if (idOperazioneR) {
        ListaIdTipoCarico.push('PR')
        ListaIdTipoCarico.push('TR')
      }
      let idOperazioneD = idOperazioneRD.includes('d');

      if (idOperazioneD) {
        ListaIdTipoCarico.push('PD')
        ListaIdTipoCarico.push('TD')
      }

    }

    ListaIdTipoCarico.push('DT');



    this.rowData['idOperazioneCausale'] = formData.causale_Id_Operazione


    this.rowData['ListaIdTipoCarico'] = ListaIdTipoCarico;

    this.rowData['quantitaKg'] = formData.quantitaKg;
    /*   if(formData.totaleDifferenzaPesoDaScaricare>0 && idMovimento >0){
        this.rowData['totaleDifferenzaPesoDaScaricare'] = formData.totaleDifferenzaPesoDaScaricare
      }else{
        this.rowData['totaleDifferenzaPesoDaScaricare'] = formData.quantitaKg;
      } */

    // if (!formData.quantitaKg) {
    //   formData.quantitaKg = 0
    // }
    this.rowData['totaleDifferenzaPesoDaScaricare'] = formData.quantitaKg;

    this.rowData['idCausale'] = formData.idCausale;

    this.rowData['dataRegistrazione'] = formData.dataRegistrazione;
    this.rowData['lottoProduzione'] = formData.idLotto;
    this.rowData['idLotto_Sede'] = formData.idLotto_Sede;

    filter += "?IdMovimento=" + idMovimento;

    if (dataToSend['dataRegistrazione']) {
      filter += "&DataRegistrazione=" + this.dateParse(dataToSend['dataRegistrazione']);

    } else {

      alert("C'è stato un problema data registrazione documento mancante", 'Errore!')
      return;
    }

    this.rowData['oraRegistrazione'] = formData.oraRegistrazione;
    if (dataToSend['oraRegistrazione']) {
      filter += "&Ora=" + dataToSend['oraRegistrazione'];
    }

    this.rowData['eer'] = formData.eer;

    if (dataToSend['eer']) {
      filter += "&EER=" + dataToSend['eer'];
    } else {

      alert("C'è stato un problema codice eer mancante", 'Errore!')
      return;
    }

    this.rowData['idStatoFisico'] = formData.idStatoFisico;
    if (dataToSend['idStatoFisico']) {
      filter += "&idStatoFisico=" + dataToSend['idStatoFisico'];
    } else {

      alert("C'è stato un problema stato fisico mancante", 'Errore!')
      return;
    }
    if (dataToSend['idProduttore']) {
      filter += "&IdProduttoreMovScarico=" + dataToSend['idProduttore'];
    } else {

      alert("C'è stato un problema produttore mov.scarico mancante", 'Errore!')
      return;
    }

    this.rowData['riferimentoEER'] = formData.riferimentoEER;
    if (dataToSend['riferimentoEER']) {
      filter += "&RiferimentoEER=" + dataToSend['riferimentoEER'];
    }

    this.rowData['IdCantiereFuoriUL'] = formData.idCantiereFuoriUl;
    if (dataToSend['idCantiereFuoriUl']) {
      filter += "&IdCantiereFuoriUL=" + dataToSend['idCantiereFuoriUl'];
    }

    this.rowData['listaHP'] = formData.listaHP;

    if (dataToSend['listaHP']) {
      dataToSend['listaHP'].forEach(hp => {
        filter += "&ListaHP=" + hp;
      })

    }
    ListaIdTipoCarico.forEach(tipoCarico => {
      filter += "&ListaIdTipoCarico=" + tipoCarico;

    })



    let listaMagazziniDestinatario = dataToSend['listaMagazziniDestinatario'];
    this.rowData['ListaIdMagazzino'] = listaMagazziniDestinatario
    if (listaMagazziniDestinatario) {
      listaMagazziniDestinatario.forEach(res => {
        filter += "&ListaIdMagazzino=" + res;
      })

    }

    //this.rowData['ListaIdTipoCarico'] = formData.tipoCarico;

    if (ListaIdTipoCarico) {
      ListaIdTipoCarico.forEach(tipoCarico => {
        filter += "&ListaIdTipoCarico=" + tipoCarico;
      })

    }

    if (formData.idPosizioneCausale) {

      filter += "&ListaIdPosizioniDiCarico=" + formData.idPosizioneCausale;

    }

    if (formData.idLotto) {
      filter += "&IdLotto=" + dataToSend['idLotto'];
    }

    this.maxTotaleScaricabile = 0
    const api = 'MovimentoRifiuti/GetListaCarichiDaAbbinare'
    this.anagraficaService.getElenco(api, '', filter).then((resLista: any[]) => {

      this.rowData['listaCarichiDaAbbinare'] = resLista;
      resLista.map(resss => {

        if (idMovimento > 0) {
          this.maxTotaleScaricabile += resss.pesoScaricato;
        } else {
          this.maxTotaleScaricabile += resss.residuo;
        }


      })


      this.startForm = true;


    })


    this.CustomButtonForm = [

      {

        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Salva movimento',
        hint: 'F10 per salvare',
        icon: "glyphicon icon-salva-form",
        event: 'saveScarico',
        disabled: this.disabledButtons
      },
      {

        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        hint: 'Chiudi schermata carico',
        stylingMode: 'text',
        text: 'ritorna',
        icon: "glyphicon icon-annulla-form",
        event: 'returnCarico',

      },
    ]
  }

  formEventCarichi(event) {

    //console.log('formEventCarichi', event);

    if (event.name == 'formContentInitializzed') {
      if (this.rowData['idOperazioneCausale'] == 'B1') {
        event.component.beginUpdate();
        if (this.rowData['quantitaKg'] == 0 || this.rowData['quantitaKg'] == null) {
          setTimeout(() => {
            event.component.getEditor('scaricoAutomatico')
            console.log('scaricoAutomatico-->', event.component.getEditor('scaricoAutomatico'))

            event.component.getEditor('scaricoAutomatico').option('disabled', true)
            console.log('scaricoAutomaticoOpt-->', event.component.getEditor('scaricoAutomatico').option())
            //.option('disabled', true);
          }, 300);
          //event.component.itemOption('gestioneScarichi.scaricoAutomatico', 'disabled', true);
        }

        event.component.endUpdate()
      }
      if (this.disabledButtons) {

        event.component.beginUpdate();

        event.component.itemOption('gestioneScarichi.svuotaColonnaScarico', 'cssClass', 'd-none')
        event.component.itemOption('gestioneScarichi.scaricoChiusura', 'cssClass', 'd-none')
        event.component.itemOption('gestioneScarichi.scaricoPercentuale', 'cssClass', 'd-none')
        event.component.itemOption('gestioneScarichi.scaricoAutomatico', 'cssClass', 'd-none');

        if (this.rowData['idOperazioneCausale'] == 'B1') {

          event.component.itemOption('gestioneScarichi.scaricoAutomatico', 'cssClass', 'd-none');


        }


        event.component.endUpdate()
      }
    }


    if (event.name == 'grigliaOnInitialized') {

      if (this.disabledButtons) {
        event.griglia
        console.log('grigliaCambiata-->', event.griglia)
        event.griglia.columnOption('pesoScaricato', 'allowEditing', false);
        event.griglia.columnOption('differenzaPeso', 'allowEditing', false);
        event.griglia.columnOption('salvaCompleta', 'allowEditing', false);
        event.griglia.columnOption('selezionaCarico', 'visible', false);
        event.griglia.option('selection', { 'mode': 'single', 'showCheckBoxesMode': 'none', 'allowSelectAll': false, 'deferred': false })
        console.log('grigliaCambiata columnOption', event.griglia.option('selection', { 'mode': 'single' }));

      }

    }

    if (event.name == 'onCellPrepared') {


      if (event.column.type == "selection") {
        if (this.disabledButtons) {
          event.column.visible = false;
          console.log('onCellPrepared-->', event)

          return event
        }

      }
      if (event.column.type == "buttons") {
        if (this.disabledButtons) {
          //event.column.buttons[1].visible = false;
          event.column.visible = false
          console.log('onCellPrepared', event);
        }

      }

    }


    if (event.name == 'selectedItemTag') {

      const campo = event.campo.dataField;
      let dataToSend = [];

      if (campo == "ListaIdMagazzino") {
        dataToSend = event.formData
        this.getCarico(dataToSend);
      }

      if (campo == "ListaIdTipoCarico") {
        dataToSend = event.formData
        this.getCarico(dataToSend);
      }

      if (campo == "listaHP") {
        dataToSend = event.formData
        this.getCarico(dataToSend);
      }
      if (campo == "ListaIdPosizioniDiCarico") {
        dataToSend = event.formData
        this.getCarico(dataToSend);
      }


    }

    if (event.name == "ValueChangedLista") {

      if (event.campo.dataField == "IdCantiereFuoriUL") {

        let dataToSend = event.formData;

        dataToSend.IdCantiereFuoriUL = event.valore

        this.getCarico(dataToSend);

      }
      if (event.campo.dataField == "lottoProduzione") {

        let dataToSend = event.formData;

        dataToSend.lottoProduzione = event.value

        this.getCarico(dataToSend);

      }

    }

    /* if(event.name ==  'selectedOnInitTag'){
      if(event.campo.dataField == 'ListaIdMagazzino'){
        event.component.option('dataSource').load().then(
          (data)=>{
            console.log('selectedOnInitTag-->',data);
            let dataSel = data.filter()
            event.component.option('value',data)
          }
        )
      }
      

    } */

    if (event.name == "onValueChange") {

      const campo = event.campo.dataField;
      if (campo == 'totaleDifferenzaPesoDaScaricare') {

        if (event.value > this.maxTotaleScaricabile) {
          //      alert('Il peso inserito:' + event.value + 'Kg è superiore alla somma delle quantità residue dei carichi','Attenzione!');

          //          event.masterComponent.updateData('totaleDifferenzaPesoDaScaricare',null)
        } else {
          const val = event.value;

        }
      }
      if (campo == "riferimentoEERT") {

        let dataToSend = event.formData;

        this.getCarico(dataToSend);

      }
    }

    if (event.name == 'onValueChanged') {

      const campo = event.campo.dataField;
      if (campo == "produttoreMovCarico") {

        let dataToSend = event.formData
        this.getCarico(dataToSend);

      }

    }


    if (event.name == 'selectionRowGridList') {

      if (this.rowData['idOperazioneCausale'] == 'B1') {

        if (this.rowData['quantitaKg'] == 0) {

          event.component.getEditor('scaricoAutomatico').option('disabled', false);
          //event.component.itemOption('gestioneScarichi.scaricoAutomatico','cssClass','d-block')
        }


      }

      return
      if (typeof event.row.data == 'undefined') {
        return
      }
      if (event.row.isSelected) {
        event.component.deselectRows(event.row.key);
        return
      } else {
        event.component.selectRows(event.row.key, true);
        return
      }
      event.component.deselectAll();



      const formData = this.formSoggetto.formEdit.formData;

      const listaCarichiDaAbbinare = formData.listaCarichiDaAbbinare;
      const currentRowIndex = event.row.rowIndex

      for (let k = 0; k < listaCarichiDaAbbinare.length; k++) {

        let rowIndex = event.component.getRowIndexByKey(listaCarichiDaAbbinare[k])
        event.component.selectRows(listaCarichiDaAbbinare[k], true)

        /* let rowHtml = event.component.getRowElement(rowIndex);
        console.log('rowHtml',rowHtml)
        if(rowHtml[0]){
          rowHtml[0].classList.add('selected-row')
        } */


        if (currentRowIndex === rowIndex) {
          //event.component.selectRows(lCarico,true)
          break;
        }



      }

      let dataSend = {
        masterComponent: this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance,
        data: {
          listaCarichiDaAbbinare: listaCarichiDaAbbinare
        }
      }


      //this.scaricoAutomatico(dataSend)

      //event.component.selectRows(event.row.key,true)


    }

    if (event.event == "onSavingDynamiGrid") {
      console.log('formEventCarichi', event)

      this.totalPesoScaricato = event.component.dynamicGridComponent.instance.getTotalSummaryValue("pesoScaricato");
      //this.formSoggetto.formEdit.instance.updateData('totalePesoScaricato', this.totalPesoScaricato)
      //this.formSoggetto.formRefreshInputData('totalePesoScaricato',this.totalPesoScaricato)

    }



    if (event == 'saveScarico') {

      setTimeout(() => {
        const formData = this.formSoggetto.formEdit.formData;

        const listaCarichiDaAbbinare = formData.listaCarichiDaAbbinare;
        if (!listaCarichiDaAbbinare) {
          return
        }
        let pesoScaricato = 0;
        let residuo = 0;
        let qtaResidua = 0;
        let differenzaPeso = 0;

        listaCarichiDaAbbinare.forEach(res => {

          if (res.differenzaPeso) {

            differenzaPeso += parseFloat(res.differenzaPeso)
          }
          if (res.pesoScaricato) {
            pesoScaricato += parseFloat(res.pesoScaricato)
          }
          /*  if (res.pesoScaricato) {
            
   
           } */



        })
        //pesoScaricato = pesoScaricato
        let quantitaKg = !this.rowData['quantitaKg'] ? 0 : this.rowData['quantitaKg']
        if (formData.idOperazioneCausale == 'B1' && quantitaKg == 0) {
          quantitaKg = pesoScaricato
        }
        // this.totalPesoScaricato = pesoScaricato + differenzaPeso;
        // let risultatoFormattato = this.totalPesoScaricato.toFixed(3)
        let risultatoFormattato = pesoScaricato + differenzaPeso;
        console.log(risultatoFormattato)
        let residuoFormattato = quantitaKg - Number(risultatoFormattato);

        if (residuoFormattato > 0) {
          alert(`Il totale scaricato è di ${Number(risultatoFormattato)}. Il totale da scaricare è ${Number(quantitaKg)}. Non puoi scaricare ${Number(pesoScaricato)} perchè inferiore al totale da scaricare`, 'Attenzione');
          return
        }
        if (residuoFormattato < 0) {

          alert(`Il totale scaricato è di ${Number(risultatoFormattato)}. Il totale da scaricare è ${Number(quantitaKg)}. Non puoi scaricare ${Number(pesoScaricato)} perchè supera il totale da scaricare`, 'Attenzione');
          return
        }
        if (this.newdata && this.newdata.pesoScaricato > this.rowData['quantitaKg'] && this.rowData['totaleDifferenzaPesoDaScaricare'] <= 0) {
          alert('Stai inserendo un quantità superiore a quella indicata nel movimento', 'Attenzione')
          return
        } else if (this.newdata && this.oldData && this.newdata.pesoScaricato > this.oldData.residuo) {
          alert('Stai inserendo un quantità superiore al peso residuo', 'Attenzione')
          return
        }
        if (formData.idOperazioneCausale != 'B1') {
          if (risultatoFormattato == this.rowData['quantitaKg']) {
            let dataOuptput = {
              listaCarichiDaAbbinare: formData.listaCarichiDaAbbinare,
              totaleDifferenzaPesoDaScaricare: formData.totaleDifferenzaPesoDaScaricare,
              quantitaKg: quantitaKg,
              idLotto: formData.lottoProduzione,
              idCantiereFuoriUl: formData.IdCantiereFuoriUL,
              idCliente: formData.cliente,
              listaHP: formData.listaHP,
              /* idProduttore:formData.produttoreMovCarico, */
              event: 'saveScarico'
            }

            this.outputEmit.emit(dataOuptput)
          }
        } else if (formData.idOperazioneCausale == 'B1') {
          if (formData.quantitaKg !== undefined && formData.quantitaKg !== null) {
            let dataOuptput = {
              listaCarichiDaAbbinare: formData.listaCarichiDaAbbinare,
              totaleDifferenzaPesoDaScaricare: formData.totaleDifferenzaPesoDaScaricare,
              quantitaKg: quantitaKg,
              idLotto: formData.lottoProduzione,
              idCantiereFuoriUl: formData.IdCantiereFuoriUL,
              idCliente: formData.cliente,
              listaHP: formData.listaHP,
              /* idProduttore:formData.produttoreMovCarico, */
              event: 'saveScarico'
            }

            this.outputEmit.emit(dataOuptput)
          } else {
            if (this.totalPesoScaricato === 0) alert('Selezionare almeno un peso da scaricare se il peso del movimento non è definito', 'Attenzione')
            else {
              formData.totaleDifferenzaPesoDaScaricare = this.totalPesoScaricato
              let dataOuptput = {
                listaCarichiDaAbbinare: formData.listaCarichiDaAbbinare,
                totaleDifferenzaPesoDaScaricare: formData.totaleDifferenzaPesoDaScaricare,
                quantitaKg: quantitaKg,
                idLotto: formData.lottoProduzione,
                idCantiereFuoriUl: formData.IdCantiereFuoriUL,
                idCliente: formData.cliente,
                listaHP: formData.listaHP,
                /* idProduttore:formData.produttoreMovCarico, */
                event: 'saveScarico'
              }

              this.outputEmit.emit(dataOuptput)
            }
          }
        }
      }, 500)

    }

    if (event == 'returnCarico') {
      let dataOuptput = {
        listaCarichiDaAbbinare: [],
        name: 'return'
      }

      this.outputEmit.emit(dataOuptput)
    }

    if (event.name == 'onRowValidating') {

      this.newdata = event.newData;
      this.oldData = event.oldData

      // if (data.pesoScaricato > this.rowData['quantitaKg'] && this.rowData['totaleDifferenzaPesoDaScaricare'] <= 0) {

      //   event.isValid = false;
      //   event.errorText = 'Stai inserendo un quantità superiore a quella indicata nel movimento'

      // } else if (data.pesoScaricato > oldData.residuo) {
      //   event.isValid = false;
      //   event.errorText = 'Stai inserendo un quantità superiore al peso residuo';

      // } else {
      //   event.isValid = true;
      //   event.errorText = null;

      // }
    }

    if (event.name == 'scaricoPercentuale') {
      event.masterComponent = this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance
      this.scaricoPercentuale(event);

      setTimeout(() => {
        if (this.textPercentValue > 0) {
          event.masterComponent.clearSelection()
        }
      }, 500);


    }
    if (event.name == 'scaricoAutomatico') {
      event.masterComponent = this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance
      this.scaricoAutomatico(event)
    }

    if (event.name == 'scaricoChiusura') {
      event.masterComponent = this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance
      this.scaricoChiusura(event)
    }

    if (event.name == 'svuotaColonnaScarico') {
      event.masterComponent = this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance
      this.svuotaColonnaScarico(event)
    }
  }

  getCarico(dataToSend) {

    let filter = ''
    if (typeof dataToSend['idMovimento'] == 'undefined') {
      return;
    }
    filter += "?IdMovimento=" + dataToSend['idMovimento'];

    if (dataToSend['dataRegistrazione']) {
      filter += "&DataRegistrazione=" + this.dateParse(dataToSend['dataRegistrazione']);
    }

    if (dataToSend['oraRegistrazione']) {
      filter += "&Ora=" + dataToSend['oraRegistrazione'];
    }

    if (dataToSend['eer']) {
      filter += "&EER=" + dataToSend['eer'];
    }
    // if (dataToSend['riferimentoEERT']) {
    //   filter += "&RiferimentoEER=" + null;
    // } else {
    //   filter += "&RiferimentoEER=" + dataToSend['riferimentoEER'];
    // }

    if (!dataToSend['riferimentoEERT']) {
      filter += "&RiferimentoEER=" + dataToSend['riferimentoEER'];
    }

    if (dataToSend['idStatoFisico']) {
      filter += "&idStatoFisico=" + dataToSend['idStatoFisico'];
    }

    if (dataToSend['IdProduttoreMovScarico']) {
      filter += "&IdProduttoreMovScarico=" + dataToSend['IdProduttoreMovScarico'];
    }

    if (dataToSend['IdCantiereFuoriUL']) {
      filter += "&IdCantiereFuoriUL=" + dataToSend['IdCantiereFuoriUL'];
    }
    if (dataToSend['lottoProduzione']) {
      filter += "&IdLotto=" + dataToSend['lottoProduzione'];
    }

    /* if (dataToSend['riferimentoEER']) {
      filter += "&RiferimentoEER=" + dataToSend['riferimentoEER'];
    } */

    if (dataToSend['listaHP']) {
      dataToSend['listaHP'].forEach(hp => {
        filter += "&ListaHP=" + hp;
      })

    }
    if (dataToSend['ListaIdMagazzino']) {
      dataToSend['ListaIdMagazzino'].forEach(mazzino => {
        filter += "&ListaIdMagazzino=" + mazzino;
      })

    }

    if (dataToSend['ListaIdTipoCarico']) {
      dataToSend['ListaIdTipoCarico'].forEach(tipoCarico => {
        filter += "&ListaIdTipoCarico=" + tipoCarico;
      })

    }

    if (dataToSend['ListaIdPosizioniDiCarico']) {
      dataToSend['ListaIdPosizioniDiCarico'].forEach(posizioniDiCarico => {
        filter += "&ListaIdPosizioniDiCarico=" + posizioniDiCarico;
      })
    }

    if (filter != '') {
      const api = 'MovimentoRifiuti/GetListaCarichiDaAbbinare'
      this.anagraficaService.getElenco(api, '', filter).then((resLista: any[]) => {

        //this.rowData['listaCarichiDaAbbinare'] = resLista

        this.formSoggetto.formRefreshInputData('listaCarichiDaAbbinare', resLista);

        this.formSoggetto.dynamicComponentItem.datasource = resLista


      })
    }
  }

  scaricoPercentuale(ev) {


    let listaCarichiDaAbbinare
    let getSelectedRow = [];
    let totDaScaricare = 0
    getSelectedRow = ev.masterComponent.getSelectedRowsData();

    if (getSelectedRow.length > 0) {

      listaCarichiDaAbbinare = getSelectedRow
      listaCarichiDaAbbinare = listaCarichiDaAbbinare.sort((a, b) => {
        return a.timeStamp - b.timeStamp; // sort in ascendig order
      })
      this.svuotaColonnaScarico(ev)
    } else {
      alert('Selezionare almeno una riga', 'Attenzione')
      return

    }

    listaCarichiDaAbbinare.map(res => {
      totDaScaricare += res.residuo
    })

    this.formSoggetto.formEdit.instance.updateData('totalePesoScaricato', null);

    const currentListaCarichiDaAbbinare = this.formSoggetto.formEdit.formData.listaCarichiDaAbbinare

    this.totalPesoScaricato = 0

    if (listaCarichiDaAbbinare.length > 0) {

      let peso = this.rowData['quantitaKg'];

      let scaricato = 0;

      if ((totDaScaricare < peso) && this.textPercentValue == null) {
        alert('Selezionare più righe per proseguire ', 'Attrenzione!');
        return
      }

      const quantitaKg = this.formSoggetto.formEdit.formData.totaleDifferenzaPesoDaScaricare;

      if (quantitaKg == 0 && this.textPercentValue == null) {

        this.showPopupPercentuale = true;


        return
      }

      if (this.textPercentValue > 0) {
        peso = totDaScaricare;

      }

      const lengthCarichi = listaCarichiDaAbbinare.length - 1

      for (let x = 0; x <= lengthCarichi; x++) {

        if (scaricato == peso) {
          return
        }
        //https://www.studenti.it/come-dividere-un-numero-in-parti-direttamente-proporzionali-a-numeri-dati.html#:~:text=Come%20prima%20cosa%20calcolate%20la,proporzionale%20alla%20parte%20da%20trovare)

        let ScaricoPerc
        if (this.textPercentValue == null) {
          ScaricoPerc = ((listaCarichiDaAbbinare[x].residuo * peso) / totDaScaricare).toFixed(0)
        } else {
          ScaricoPerc = (listaCarichiDaAbbinare[x].residuo * this.textPercentValue / 100).toFixed(0);
          // ScaricoPerc = listaCarichiDaAbbinare[x].residuo - ScaricoPerc;
        }


        //let ScaricoPerc = ((r.residuo / totDaScaricare) * pesoScaricabile).toFixed(1)

        let index = currentListaCarichiDaAbbinare.findIndex(list => list.contatore == listaCarichiDaAbbinare[x].contatore)
        if (scaricato <= peso) {

          if (ScaricoPerc <= listaCarichiDaAbbinare[x].residuo) {

            if (index >= 0) {

              //scaricoRifiuto = newResiduo;
              ev.masterComponent.cellValue(index, 'pesoScaricato', ScaricoPerc);
              listaCarichiDaAbbinare[x].pesoScaricato = ScaricoPerc

              scaricato += parseFloat(ScaricoPerc)

              currentListaCarichiDaAbbinare[index] = listaCarichiDaAbbinare[x]
              ev.masterComponent.deselectRows(index)

            }

          } else {
            //alert('La quantità:' +ScaricoPerc+ ' è superiore al peso residuo','Attenzione!') ;
            return
          }


        }


      }


      setTimeout(() => {



        if (scaricato == peso) {


          this.formSoggetto.formRefreshInputData('listaCarichiDaAbbinare', currentListaCarichiDaAbbinare) //formEdit.instance.updateData();
          this.totalPesoScaricato = scaricato;
          this.formSoggetto.formRefreshInputData('totalePesoScaricato', this.totalPesoScaricato);

          let ps = 0
          currentListaCarichiDaAbbinare.forEach(ress => {


            if (ress.pesoScaricato) {
              ps += parseFloat(ress.pesoScaricato);
            }


          })
          let result = 0

          result = peso - ps;
          if (result != 0) {
            let index = currentListaCarichiDaAbbinare.findIndex(res => { return res.pesoScaricato != null })
            if (index >= 0) {

              let residuo = parseFloat(currentListaCarichiDaAbbinare[index].pesoScaricato) + result;

              ev.masterComponent.cellValue(index, 'pesoScaricato', residuo);


            }
          }

          ev.masterComponent.clearSelection();

        }
        this.textPercentValue = null
      }, 300);



      //console.log('scaricoAutomatico', listaCarichiDaAbbinare);
    }


  }

  scaricoAutomatico(ev) {


    const isSalvaCompleta = this.formSoggetto.formEdit.formData.salvaCompleta
    let listaCarichiDaAbbinare
    let getSelectedRow = []
    getSelectedRow = ev.masterComponent.getSelectedRowsData()
    if (getSelectedRow.length > 0) {
      listaCarichiDaAbbinare = getSelectedRow
      listaCarichiDaAbbinare = listaCarichiDaAbbinare.sort((a, b) => {
        return a.timeStamp - b.timeStamp; // sort in ascendig order
      })
    } else {
      listaCarichiDaAbbinare = this.formSoggetto.formEdit.formData.listaCarichiDaAbbinare;
    }


    const totaleDifferenzaPesoDaScaricare = this.formSoggetto.formEdit.formData.totaleDifferenzaPesoDaScaricare;
    let pesoTotaleMovimento = this.rowData['quantitaKg'];

    if (pesoTotaleMovimento == 0 && this.rowData['idOperazioneCausale'] == 'B1') {
      listaCarichiDaAbbinare.map(resQ => {
        pesoTotaleMovimento += resQ.residuo
      })
    }
    if (totaleDifferenzaPesoDaScaricare) {

      setTimeout(() => {
        this.scaricoRifuto(listaCarichiDaAbbinare, totaleDifferenzaPesoDaScaricare, ev, false);

        ev.masterComponent.clearSelection()
      }, 300);

      return;

    } else {
      setTimeout(() => {
        this.scaricoRifuto(listaCarichiDaAbbinare, pesoTotaleMovimento, ev, false)
        ev.masterComponent.clearSelection();
        if (this.rowData['idOperazioneCausale'] == 'B1') {
          this.formSoggetto.formEdit.instance.getEditor('scaricoAutomatico').option('disabled', true);
        }
      }, 300);
    }



  }

  scaricoChiusura(ev) {



    let listaCarichiDaAbbinare
    let getSelectedRow = []
    getSelectedRow = ev.masterComponent.getSelectedRowsData()
    if (getSelectedRow.length > 0) {
      listaCarichiDaAbbinare = getSelectedRow
      listaCarichiDaAbbinare = listaCarichiDaAbbinare.sort((a, b) => {
        return a.timeStamp - b.timeStamp; // sort in ascendig order
      })

    } else {
      alert('Selezionare almeno una riga', 'Attenzione')
      return

    }



    let pesoTotaleDaScaricare = 0
    listaCarichiDaAbbinare.map(resQ => {
      pesoTotaleDaScaricare += resQ.residuo
    })
    if (pesoTotaleDaScaricare > 0) {

      setTimeout(() => {
        if (this.rowData['idOperazioneCausale'] == 'B1' && this.rowData['quantitaKg'] == 0) {
          this.scaricoRifuto(listaCarichiDaAbbinare, pesoTotaleDaScaricare, ev, false);
        } else {
          this.scaricoRifuto(listaCarichiDaAbbinare, pesoTotaleDaScaricare, ev, true);
        }


        ev.masterComponent.clearSelection()
      }, 300);

      return;

    }



  }

  scaricoRifuto(listaCarichiDaAbbinare, peso, ev, isDifferenzaPeso) {

    this.svuotaColonnaScarico(ev)

    let differenzaPeso = this.rowData['quantitaKg'] - peso;

    this.formSoggetto.formRefreshInputData('totalePesoScaricato', null);

    //this.totalPesoScaricato = 0

    const currentListaCarichiDaAbbinare = this.formSoggetto.formEdit.formData.listaCarichiDaAbbinare



    if (listaCarichiDaAbbinare.length > 0) {


      let newResiduo = peso;
      let scaricato = 0;
      let checkDiff = 0
      let lista = listaCarichiDaAbbinare.forEach((r, rowIndex) => {


        if (scaricato == peso) {
          return r
        }

        /* if (peso >= newResiduo) { */

        let scaricoDiff = newResiduo - r.residuo;
        let index = currentListaCarichiDaAbbinare.findIndex(list => list.contatore == r.contatore)
        if (scaricato <= peso) {
          let scaricoRifiuto = newResiduo - scaricoDiff

          if (scaricoDiff < 0) {



            if (index >= 0) {



              scaricoRifiuto = newResiduo;
              ev.masterComponent.cellValue(index, 'pesoScaricato', scaricoRifiuto);
              r.pesoScaricato = scaricoRifiuto
              newResiduo = newResiduo - scaricoRifiuto;
              scaricato += scaricoRifiuto
              if (isDifferenzaPeso) {
                let differenza = (scaricoRifiuto * differenzaPeso) / peso;

                r.differenzaPeso = differenza.toFixed(3);
                ev.masterComponent.cellValue(index, 'differenzaPeso', differenza.toFixed(3));
              }

              currentListaCarichiDaAbbinare[index] = r;
              ev.masterComponent.deselectRows(index);
              return r
            }

            scaricoRifiuto = newResiduo;
          }

          ev.masterComponent.cellValue(index, 'pesoScaricato', scaricoRifiuto);
          r.pesoScaricato = scaricoRifiuto
          newResiduo = newResiduo - scaricoRifiuto;
          scaricato += scaricoRifiuto

          let differenza = (scaricoRifiuto * differenzaPeso) / peso;


          if (isDifferenzaPeso) {

            r.differenzaPeso = differenza.toFixed(3);
            checkDiff += parseFloat(differenza.toFixed(3))
            ev.masterComponent.cellValue(index, 'differenzaPeso', differenza.toFixed(3));

          }

          ev.masterComponent.deselectRows(index)
        }
        /* } */
        currentListaCarichiDaAbbinare[index] = r
        return r

      })



      setTimeout(() => {
        if (scaricato == peso) {

          this.formSoggetto.formRefreshInputData('listaCarichiDaAbbinare', currentListaCarichiDaAbbinare) //formEdit.instance.updateData();
          this.totalPesoScaricato = scaricato;
          this.formSoggetto.formRefreshInputData('totalePesoScaricato', this.totalPesoScaricato);
          if (isDifferenzaPeso) {
            let ps = 0
            let dp = 0
            currentListaCarichiDaAbbinare.forEach(ress => {

              if (ress.differenzaPeso) {

                dp += parseFloat(ress.differenzaPeso);
              }
              if (ress.pesoScaricato) {
                ps += parseFloat(ress.pesoScaricato);
              }


            })



            let result = 0
            let totalPesoScaricato = ps + dp;
            result = this.rowData['quantitaKg'] - totalPesoScaricato;
            if (result != 0) {
              let index = currentListaCarichiDaAbbinare.findIndex(res => { return res.pesoScaricato != null })
              let indexD = currentListaCarichiDaAbbinare.findIndex(res => { return res.differenzaPeso % 1 })

              if (index >= 0) {

                let diffRes = parseFloat(currentListaCarichiDaAbbinare[index].differenzaPeso) + result;

                ev.masterComponent.cellValue(index, 'differenzaPeso', diffRes);

                //
              } else {
                //currentListaCarichiDaAbbinare[indexD].differenzaPeso = parseFloat(listaCarichiDaAbbinare[indexD].differenzaPeso) - result;
                //ev.masterComponent.cellValue(indexD, 'differenzaPeso', (currentListaCarichiDaAbbinare[index].differenzaPeso -  result));
              }
            }




          }
          //ev.masterComponent.refresh();
          //this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance.deselectAll()
          //this.formSoggetto.formRefreshInputData('listaCarichiDaAbbinare', lista)
        } else {
          if (scaricato > peso) {


            if (checkDiff >= 1) {
              // ev.masterComponent.cellValue(0, 'differenzaPeso', differenza);
            }
          }
          //alert('Rimangono ancora:'  + newResiduo +' ripartisci il valore nella colonna differenza peso' , 'Attenzione!')
          //this.formSoggetto.formEdit.instance.updateData('listaCarichiDaAbbinare', lista);
          /* if (isSalvaCompleta) {

            this.formSoggetto.formRefreshInputData('listaCarichiDaAbbinare', lista);
            this.totalPesoScaricato = scaricato;
            this.formSoggetto.formRefreshInputData('totalePesoScaricato', this.totalPesoScaricato)

          } else {
            listaCarichiDaAbbinare.map((r, row) => {

              // r.pesoScaricato = null;

              // ev.masterComponent.cellValue(row, 'pesoScaricato', null);
              //ev.masterComponent.cellValue(row, 'differenzaPeso', null);
            })

            
 */
        }



      }, 300);





    }


    /* setTimeout(() => {
      listaCarichiDaAbbinare.sort((a, b) => {
        return a.contatore - b.contatore; // sort in descending order
      })
      ev.masterComponent.option('dataSource', listaCarichiDaAbbinare)
      ev.masterComponent.refresh();
    }, 300); */

  }

  svuotaColonnaScarico(ev) {

    let listaCarichiDaAbbinare = []
    if (typeof ev.data != 'undefined') {
      listaCarichiDaAbbinare = ev.data.listaCarichiDaAbbinare
    } else {
      this.formSoggetto.formEdit.formData.listaCarichiDaAbbinare
    }



    this.totalPesoScaricato = 0

    if (listaCarichiDaAbbinare.length > 0) {


      listaCarichiDaAbbinare.map((r, row) => {

        r.pesoScaricato = null;
        r.differenzaPeso = null
        ev.masterComponent.cellValue(row, 'pesoScaricato', null);
        ev.masterComponent.cellValue(row, 'differenzaPeso', null);
      })
      this.formSoggetto.formEdit.instance.updateData('totalePesoScaricato', null);
    }


  }

  setPercent($event) {


    this.showPopupPercentuale = false;
    let event = {
      masterComponent: this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance
    }
    this.scaricoPercentuale(event);

    setTimeout(() => {
      this.formSoggetto.dynamicComponentItem.dynamicGridComponent.instance.clearSelection();
    }, 300);
  }


  onClickChiudiOverlay($event) {
    this.showPopupPercentuale = false;
  }

  gestZIndex(e) {
    e.component.content().style('z-index', '501')
  }
}
